import { useEffect } from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

const GA_ID = "G-XP026ST2TK";

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";

// dataLayer + gtag
window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

// Default consent: denied
gtag("consent", "default", {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "denied",
  personalization_storage: "denied",
  security_storage: "denied",
});

function updateGtagConsent() {
  gtag("consent", "update", {
    analytics_storage: CookieConsent.acceptedCategory(CAT_ANALYTICS) ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  });
}

function loadGtag() {
  if (document.getElementById("gtag-script")) return;
  const script = document.createElement("script");
  script.id = "gtag-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  gtag("js", new Date());
  gtag("config", GA_ID);
}

const BASE = import.meta.env.BASE_URL || '/';

export default function CookieConsentInit() {
  useEffect(() => {
    CookieConsent.run({
      cookie: {
        name: "cc_cookie",
      },

      hideFromBots: false,

      guiOptions: {
        consentModal: {
          layout: "cloud inline",
          position: "middle center",
          equalWeightButtons: true,
          flipButtons: false,
        },
        preferencesModal: {
          layout: "box",
          equalWeightButtons: true,
          flipButtons: false,
        },
      },

      onFirstConsent: () => {
        updateGtagConsent();
        if (CookieConsent.acceptedCategory(CAT_ANALYTICS)) loadGtag();
      },
      onConsent: () => {
        updateGtagConsent();
        if (CookieConsent.acceptedCategory(CAT_ANALYTICS)) loadGtag();
      },
      onChange: () => {
        updateGtagConsent();
        if (CookieConsent.acceptedCategory(CAT_ANALYTICS)) loadGtag();
      },

      categories: {
        [CAT_NECESSARY]: {
          enabled: true,
          readOnly: true,
        },
        [CAT_ANALYTICS]: {
          autoClear: {
            cookies: [
              { name: /^_ga/ },
              { name: "_gid" },
            ],
          },
          services: {
            analytics_storage: {
              label: "Google Analytics",
            },
          },
        },
      },

      language: {
        default: "ro",
        translations: {
          ro: {
            consentModal: {
              title: "Folosim cookie-uri",
              description:
                "Acest site folosește cookie-uri esențiale pentru funcționarea corectă și cookie-uri de analiză pentru a înțelege cum interacționezi cu site-ul. Cookie-urile de analiză sunt activate doar după acordul tău.",
              acceptAllBtn: "Acceptă toate",
              acceptNecessaryBtn: "Doar esențiale",
              showPreferencesBtn: "Setări cookie-uri",
              footer: `
                <a href="${BASE}politica-confidentialitate">Politica de confidențialitate</a>
                <a href="${BASE}politica-cookies">Politica cookies</a>
              `,
            },
            preferencesModal: {
              title: "Preferințe cookie-uri",
              acceptAllBtn: "Acceptă toate",
              acceptNecessaryBtn: "Doar esențiale",
              savePreferencesBtn: "Salvează preferințele",
              closeIconLabel: "Închide",
              sections: [
                {
                  title: "Utilizarea cookie-urilor",
                  description:
                    "Folosim cookie-uri pentru a asigura funcționalitățile de bază ale site-ului și pentru a îmbunătăți experiența ta online.",
                },
                {
                  title: "Cookie-uri strict necesare",
                  description:
                    "Aceste cookie-uri sunt esențiale pentru funcționarea corectă a site-ului și nu pot fi dezactivate.",
                  linkedCategory: CAT_NECESSARY,
                },
                {
                  title: "Analiză și performanță",
                  description:
                    "Cookie-urile de analiză ne ajută să înțelegem cum este folosit site-ul. Toate datele sunt anonimizate.",
                  linkedCategory: CAT_ANALYTICS,
                  cookieTable: {
                    headers: {
                      name: "Cookie",
                      domain: "Serviciu",
                      description: "Descriere",
                      expiration: "Expirare",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "Google Analytics",
                        description:
                          'Cookie setat de <a href="https://business.safety.google/adscookies/">Google Analytics</a> pentru a distinge utilizatorii.',
                        expiration: "2 ani",
                      },
                      {
                        name: "_gid",
                        domain: "Google Analytics",
                        description:
                          'Cookie setat de <a href="https://business.safety.google/adscookies/">Google Analytics</a> pentru a distinge utilizatorii.',
                        expiration: "24 ore",
                      },
                    ],
                  },
                },
                {
                  title: "Mai multe informații",
                  description:
                    `Pentru orice întrebări legate de cookie-uri, te rugăm să ne <a href="${BASE}contact">contactezi</a>.`,
                },
              ],
            },
          },
        },
      },
    });
  }, []);

  return null;
}
